export default __webpack_public_path__ + "static/media/logodiadunjbgwhite.dbbb1bce.png";